import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'sham-components/services';
import { ToastService } from './services/http-error-notification.service';
import { NavigationTrackerService } from './services/navigation-tracker.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private langService = inject(LanguageService);
  private navTracker = inject(NavigationTrackerService);
  private translate = inject(TranslateService);
  protected readonly toast = inject(ToastService);
  protected readonly title = signal('store-website');
  protected closeToast() {
    this.toast.clear();
  }

  protected toastTitle(type: 'success' | 'error') {
    const key = `toast.${type}_title`;
    const translatedTitle = this.translate.instant(key);

    if (translatedTitle && translatedTitle !== key) {
      return translatedTitle;
    }

    if (type === 'success') {
      return this.translate.currentLang === 'ar' ? 'تم بنجاح' : 'Success';
    }

    return this.translate.currentLang === 'ar' ? 'حدث خطأ' : 'An Error Occurred';
  }

  ngOnInit(): void {
    this.langService.init();
  }

}
